import React from "react";
import TimeAgo from "react-timeago";
import SiteProfile from "../Site/partials/siteProfile";
import { NavLink } from "react-router-dom";

const SubscriptionList = ({ items, onView }) => {
	const list = items || [];
	if (list.length)
		return (
			<div className="inbox-body">
				<div className="inbox-body no-pad table-responsive">
					<table className="table table-inbox table-hover table-bordered">
						<thead>
							<tr>
								<th scope="col">SN</th>
								<th scope="col">Next Subscription Date </th>
								<th scope="col" className="text-success">
									Amount
								</th>
								<th scope="col">Remaining</th>
								<th scope="col-4">Site</th>
								<th scope="col" className="text-center">
									View
								</th>
							</tr>
						</thead>
						<tbody>
							{list.map((item, index) => (
								<tr key={index}>
									<td className="inbox-small-cells">
										<div className="todo-check pull-left">
											{index + 1}
										</div>
									</td>

									<td className="view-message">
										<strong>
											{Intl.DateTimeFormat("en-GB", {
												weekday: "short",
												year: "numeric",
												month: "long",
												day: "numeric"
											}).format(
												new Date(item.nextSubDate)
											)}
										</strong>
										<p className="text-muted">
											Updated{" "}
											<TimeAgo date={item.lastUpdate} />
										</p>
									</td>

									<td className="view-message">
										<h5 className="text-success">
											{item.currency}{" "}
											{Intl.NumberFormat("en-GB").format(
												item.amount
											)}
										</h5>
									</td>
									<td className="view-message">
										{item.remainingDays}{" "}
										{item.remainingDays < 2
											? "Day"
											: "Days"}
									</td>
									<td className="view-message">
										<SiteProfile site={item.site} />
									</td>
									<td className="view-message text-center">
										<NavLink
											to={{
												pathname: `/home/app-management/service-sub/${item.id}`,
												state: { item }
											}}
											title="View"
											className="mdl-button mdl-button--icon mdl-button--colored btn-default"
										>
											<i className="material-icons text-primary">
												list
											</i>
										</NavLink>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		);
	else
		return (
			<div className="text-center m-t-10 m-b-20">
				<h4 className="text-danger">
					No service subscription is added yet!
				</h4>
			</div>
		);
};

export default SubscriptionList;
